module.exports = __webpack_public_path__ + "img/down-h@3.079f5531.svg";